




























































import Vue from 'vue'
import Component from 'vue-class-component'
import {State} from 'vuex-class';
import AppRelease from '@/modules/app-router/model/AppRelease';
import UserGroupList from '@/modules/user/components/UserGroup/UserGroupList.vue';
import UserGroup from '@/modules/user/model/UserGroup';

/**
 * Administración de los grupos de usuario de una distribución
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: {UserGroupList},
})
export default class ReleaseUserGroups extends Vue {

    /**
     * Distribución de la aplicación actualmente mostrada por el componente
     */
    @State(state => state.appRouter.release)
    public release: AppRelease

    public selected: UserGroup[] = []

    public addGroupsDialog = false
    public deleteConfirmDialog = false

    public headers = [
        { text: 'ID', value: 'id'},
        { text: 'Nombre', value: 'name'},
    ]

    public search = ''

    /**
     * Añade a la distribución actual la lista de grupos seleccionados por el
     * usuario.
     */
    public addGroups () {
        this.$store.commit('appRouter/ADD_RELEASE_USER_GROUPS', this.selected)
        this.selected = []

        this.addGroupsDialog = false
    }

    /**
     * Quita de la distribución actualmente seleccionada, la lista de grupos seleccionados
     * por el usuario
     */
    public removeSelectedUserGroups () {
        this.$store.commit('appRouter/REMOVE_RELEASE_USER_GROUPS', this.selected)
        this.selected = []

        this.deleteConfirmDialog = false
    }
}
